<section class="seo-service">
    <div class="container-fluid">
        <div class="row center-align">
            <div class="col-md-6">
                <div class="service">
                    <h2>
                        {{"Design and programming of electronic store applications and websites" | translate}}
                    </h2>
                    <p>
                        {{"If you own a store or shop for selling products, you can now increase your market area and sell your products in all the areas surrounding you only by creating an online store to display and sell special products and deliver them... Do not be satisfied with your own surroundings with your shop, expand your activity only with codesroots" | translate}}
                    </p>
                </div>
            </div>
            <div class="col-md-6 text-center">
                <img src="./../../../assets/images/ecommerce.png" alt="seo" />
            </div>
        </div>
    </div>
</section>